import React from "react";

/**
 * Initiates Emergent-managed Google OAuth.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
export default function GoogleSignInButton({ next = "/", label = "Entrar com Google", testid = "google-signin" }) {
  const onClick = () => {
    const origin = window.location.origin;
    const redirect = `${origin}/auth/google/callback${next && next !== "/" ? `?next=${encodeURIComponent(next)}` : ""}`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="w-full inline-flex items-center justify-center gap-3 bg-white border border-border text-navy hover:border-gold/60 hover:bg-[hsl(var(--parchment))] px-6 py-3 rounded-full text-sm font-medium transition-colors"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#EA4335" d="M12 5.04c1.83 0 3.46.63 4.74 1.85l3.55-3.55C18.13 1.18 15.32 0 12 0 7.31 0 3.26 2.69 1.28 6.61l4.13 3.21C6.41 7.06 8.96 5.04 12 5.04z"/>
        <path fill="#4285F4" d="M23.49 12.27c0-.78-.07-1.53-.19-2.27H12v4.51h6.47c-.28 1.41-1.13 2.61-2.41 3.41l3.94 3.06c2.3-2.13 3.49-5.27 3.49-8.71z"/>
        <path fill="#FBBC05" d="M5.41 14.39c-.27-.78-.42-1.61-.42-2.39 0-.78.15-1.61.42-2.39L1.28 6.61C.46 8.27 0 10.08 0 12s.46 3.73 1.28 5.39l4.13-3z"/>
        <path fill="#34A853" d="M12 24c3.24 0 5.95-1.07 7.94-2.93l-3.94-3.06c-1.09.74-2.49 1.18-4 1.18-3.04 0-5.59-2.02-6.59-4.78l-4.13 3.21C3.26 21.31 7.31 24 12 24z"/>
      </svg>
      {label}
    </button>
  );
}
